<template>
  <div class="tab-wrap">
    <vs-tabs
      vs-alignment="center"
      ref="transferTab"
      :value="$route.query.activeTab"
    >
      <!-- KRW 입금 탭//S -->
      <vs-tab
        :label="$t('gnb.deposit/Withdrawal.menu.KRWDeposit')"
        :disabled="accounts.deposit.accountNumber === ''"
      >
        <div class="panel panel-default deposit-panel">
          <div class="panel-heading">
            <dl class="dl-horizontal">
              <dt>{{ $t("deposit.registeredAccount") }}</dt>
              <dd v-if="accounts.deposit">
                {{ accounts.deposit.bankName }}
                <br />
                {{ accounts.deposit.accountNumber }}
              </dd>
            </dl>
          </div>
          <div class="panel-body">
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              :label="$t('deposit.availableDepositAmount')"
              :placeholder="$t('deposit.availableDepositAmount')"
              class="input-custom input-block"
              v-model="availableAmount"
              >{{ availableAmount | formatNumber }}</vs-input
            >
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              :label="$t('deposit.requestedDepositAmount')"
              :placeholder="$t('deposit.requestedDepositAmount')"
              v-model="depositAmount"
              class="input-custom input-block"
            ></vs-input>
            <vs-button
              color="#f01b5c"
              type="filled"
              class="btn-block"
              @click="depositRegist"
              >입금신청</vs-button
            >
          </div>
        </div>
      </vs-tab>
      <!-- KRW 입금 탭//E -->
      <vs-tab :label="$t('deposit.title')">
        <!-- 암호화폐 입금 탭//S -->
        <vs-row class="trade-info">
          <vs-col
            vs-justify="center"
            vs-align="center"
            vs-w="5"
            class="coin-sel"
          >
            <!-- MARKET SELECT//S -->
            <span
              class="coin-name"
              :class="{ active: coinsel }"
              @click="coinsel = !coinsel"
              >{{ selectedCoin.text }}</span
            >
            <transition name="slide-fade">
              <div class="coin-sel" v-if="coinsel">
                <ul>
                  <li v-for="(wallet, index) in walletList" :key="index">
                    <span
                      @click="initCoinData(wallet)"
                      :class="{ active: selectedCoin.value == wallet.value }"
                      >{{ wallet.text }}</span
                    >
                  </li>
                  <!-- <li v-for="(coin, index) in coinList" :key="index">
                    <span @click="initCoinData(coin)" :class="{ active : selectedCoin.value == coin.value}">
                      {{coin.text}}
                    </span>
                  </li>-->
                </ul>
              </div>
            </transition>
            <!-- MARKET SELECT//E -->
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="7">
            <!-- CURRENT PRICE//S -->
            <div class="current-price text-right">
              <h3>{{ selectedCoin.available | formatNumber(8) }}</h3>
              <span class="txt-red"
                >≒ {{ selectedCoin.toKRW | formatNumber }}</span
              >
            </div>
            <!-- CURRENT PRICE//E -->
          </vs-col>
        </vs-row>
        <div class="well">
          <div class="input-custom">
            <label for class="vs-input-label">{{
              $t("deposit.address")
            }}</label>
            <textarea
              v-model="address"
              id
              rows="3"
              class="form-control"
              disabled
            ></textarea>
          </div>
          <vs-input
            v-if="selectedCoin.code === 'XRP'"
            label="데스티네이션태그"
            vs-placeholder="Placeholder"
            readonly
            v-model="selectedCoin.destinationTag"
            class="input-custom input-block"
          ></vs-input>
          <vs-row class="order-btn-wrap">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
            >
              <vs-button
                class="btn-border-default btn-block"
                type="border"
                @click="copyToClipboard"
                >{{ $t("deposit.copyAddress") }}</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
            >
              <vs-button
                class="btn-block"
                color="danger"
                type="filled"
                @click="shareAddr"
                >{{ $t("withdraw.share") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
        <div class="well" v-if="selectedCoin.qr">
          <div v-html="selectedCoin.qr"></div>
        </div>
        <!-- 암호화폐 입금 탭//E -->
      </vs-tab>
      <vs-tab :label="$t('withdraw.title')" @click="checkAuth">
        <!-- 출금 탭//S -->
        <div class="well well-black">{{ $t("withdraw.confirmAddress") }}</div>
        <vs-row class="trade-info">
          <vs-col
            vs-justify="center"
            vs-align="center"
            vs-w="5"
            class="coin-sel"
          >
            <!-- WALLET SELECT//S -->
            <span
              class="coin-name"
              :class="{ active: coinsel }"
              @click="coinsel = !coinsel"
              >{{ walletDefault.text }}</span
            >
            <transition name="slide-fade">
              <div class="coin-sel" v-if="coinsel">
                <ul>
                  <!--  v-if="wallet.active && wallet.code !== 'KRW'" -->
                  <li v-for="(wallet, index) in coinList" :key="index">
                    <span
                      @click="initWalletData(wallet)"
                      :class="{ active: walletDefault == wallet }"
                      >{{ wallet.text }}</span
                    >
                  </li>
                </ul>
              </div>
            </transition>
            <!-- WALLET SELECT//E -->
          </vs-col>
          <vs-col
            vs-justify="center"
            vs-align="center"
            vs-w="7"
            v-if="selectedWallet"
          >
            <!-- CURRENT PRICE//S -->
            <div class="current-price text-right">
              <h3>
                {{
                  selectedWallet.available
                    | formatNumber(selectedWallet.coin.code)
                }}
              </h3>
            </div>
            <!-- CURRENT PRICE//E -->
          </vs-col>
        </vs-row>
        <!-- 출금 FORM//S -->
        <div
          class="well"
          v-if="
            selectedWallet &&
              selectedWallet.coin.code === 'KRW' &&
              !withdrawSecondPhase
          "
        >
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                label="1회 한도"
                disabled
                :placeholder="$t('withdraw.quantity')"
                :value="
                  withdrawLimits.once | formatNumber(selectedWallet.coin.code)
                "
                class="input-custom disable-custom"
              ></vs-input>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                label="1일 한도"
                disabled
                :placeholder="$t('withdraw.quantity')"
                :value="
                  withdrawLimits.day | formatNumber(selectedWallet.coin.code)
                "
                class="input-custom disable-custom"
              ></vs-input>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                label="1개월 한도"
                disabled
                :placeholder="$t('withdraw.quantity')"
                :value="
                  withdrawLimits.month | formatNumber(selectedWallet.coin.code)
                "
                class="input-custom disable-custom"
              ></vs-input>
            </vs-col>
          </vs-row>

          <div class="input-group">
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              :label="$t('withdraw.quantity')"
              :placeholder="$t('withdraw.quantity')"
              class="input-custom"
              v-model="withdrawAmount"
            ></vs-input>
            <span class="input-group-btn">
              <vs-button
                color="#b5b5b5"
                size="small"
                class="btn-wide"
                type="filled"
                @click="setMaxWithdrawal"
                >최대</vs-button
              >
            </span>
          </div>
          <dl class="dl-horizontal dl-withdraw">
            <dt>{{ $t("withdraw.fee") }}</dt>
            <dd class="text-gray">{{ outFee | formatNumber(0) }}</dd>
          </dl>
          <vs-input
            label="입금은행"
            class="input-custom input-block disable-custom"
            v-model="bankName"
            disabled
          ></vs-input>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="입금계좌"
            class="input-custom input-block disable-custom"
            v-model="accountNumber"
            disabled
          ></vs-input>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="최종 출금 수량"
            placeholder="최종 출금 수량"
            v-model="totalOutAmount"
            class="input-custom input-block disable-custom input-total"
            disabled
          ></vs-input>
          <vs-button
            color="#f01b5c"
            type="filled"
            class="btn-block"
            @click="toNextWithdrawPhase"
            >2차 인증 진행</vs-button
          >
        </div>
        <!-- 출금 FORM//E -->
        <!-- 출금1 원화 FORM//S -->
        <div
          class="well withdraw-form"
          v-if="
            selectedWallet &&
              selectedWallet.coin.code === 'KRW' &&
              withdrawSecondPhase &&
              !useOTP
          "
        >
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="출금수량(수수료 포함)"
            placeholder="출금 수량"
            class="input-custom input-block disable-custom"
            disabled
            v-model="totalOutAmount"
          ></vs-input>
          <vs-input
            label="입금주소"
            placeholder="123-12345-12-123"
            class="input-custom input-block disable-custom"
            disabled
            v-model="accountNumber"
          ></vs-input>
          <vs-input
            label="입금은행"
            placeholder="OO은행"
            class="input-custom input-block disable-custom"
            disabled
            v-model="bankName"
          ></vs-input>
          <div class="sms-confirm">
            <span class="timer">{{ SMSExpireFormatted }}</span>
            <div class="input-group">
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                v-if="!useOTP"
                label="SMS 인증번호 입력"
                placeholder="인증번호(6자리)를 입력하세요."
                class="input-custom"
                v-model="withdrawAuthValue"
              ></vs-input>
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                v-if="useOTP"
                label="OTP 인증번호 입력"
                placeholder="유효시간 안에 인증번호(6자리)를 입력하세요."
                class="input-custom input-block"
                v-model="withdrawAuthValue"
              ></vs-input>
              <span class="input-group-btn" v-if="!useOTP">
                <vs-button
                  color="dark"
                  size="small"
                  class="btn-wide"
                  type="filled"
                  @click="sendSMS"
                  >발송</vs-button
                >
              </span>
            </div>
          </div>
          <p class="help-block help-withdraw">{{ $t("sms.info[1]") }}</p>
          <ul>
            <li>{{ $t("withdraw.confirmAddress") }}</li>
            <li>암호화폐 출금 시 입금주소를 꼭 확인해 주세요.</li>
            <li>{{ $t("withdraw.recovery") }}</li>
          </ul>
          <vs-checkbox v-model="agreeWithWithrawPolicy"
            >입금내역의 확인을 위해 선택된 거래내역을 제공합니다.</vs-checkbox
          >
          <vs-row class="btn-group">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-button
                color="#717171"
                type="filled"
                class="btn-block custom"
                @click="reset"
                >{{ this.$t("confirm.cancel") }}</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="8"
            >
              <vs-button
                color="#f01b5c"
                type="filled"
                class="btn-block custom"
                @click="submitWithdraw"
                >출금신청</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
        <!-- 출금1 원화 FORM//E -->
        <!-- 출금 코인 FORM//S -->
        <div
          class="well withdraw-form"
          v-if="
            selectedWallet &&
              selectedWallet.coin.code !== 'KRW' &&
              !withdrawSecondPhase
          "
        >
          <div class="input-group">
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              :label="$t('withdraw.quantity')"
              :placeholder="$t('withdraw.quantity')"
              class="input-custom"
              v-model="withdrawAmount"
            ></vs-input>
            <!-- <span class="input-group-btn">
              <vs-button color="#b5b5b5" size="small" class="btn-wide" type="filled" @click="setMaxWithdrawal">최대</vs-button>
            </span>-->
          </div>
          <dl class="dl-horizontal dl-withdraw">
            <dt>{{ $t("withdraw.fee") }}</dt>
            <dd class="text-gray">{{ selectedWallet.coin.outFee }}</dd>
          </dl>
          <div class="input-group">
            <div class="input-master input-custom vs-con-input-label">
              <label for class="vs-input-label">{{
                $t("withdraw.depositAddress")
              }}</label>
              <input
                type="text"
                :placeholder="$t('withdraw.enterDepositAddress')"
                class="form-control"
                v-model="withdrawAddress"
              />
            </div>
            <span class="input-group-btn">
              <vs-button
                color="#b5b5b5"
                size="small"
                class="btn-wide"
                type="filled"
                @click="openAddressBook"
                >{{ $t("withdraw.addressBookManage") }}</vs-button
              >
            </span>
          </div>
          <vs-input
            label="데스티네이션 태그"
            v-if="selectedWallet.coin.code === 'XRP'"
            placeholder="직접 입력"
            class="input-custom input-block"
            v-model="destinationTag"
          ></vs-input>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            :label="$t('withdraw.dinalWithdrawalQuantity')"
            :placeholder="$t('withdraw.dinalWithdrawalQuantity')"
            disabled
            :value="withdrawFinal"
            class="input-custom input-block disable-custom input-right withdraw-final"
          ></vs-input>
          <vs-button
            color="#f01b5c"
            type="filled"
            class="btn-block custom"
            @click="toNextWithdrawPhase"
            >2차 인증 진행</vs-button
          >
        </div>
        <!-- 출금 코인 FORM//E -->
        <!-- 출금1 코인 FORM//S -->
        <div
          class="well withdraw-form"
          v-if="
            selectedWallet &&
              selectedWallet.coin.code !== 'KRW' &&
              withdrawSecondPhase &&
              !useOTP
          "
        >
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="출금 수량(수수료 포함)"
            placeholder="최종 출금 수량"
            disabled
            v-model="withdrawFinal"
            class="input-custom input-block disable-custom input-right withdraw-final"
          ></vs-input>
          <div class="transfer-wallet-address">
            <dl class="dl-horizontal">
              <dt>{{ $t("withdraw.depositAddress") }}</dt>
              <!-- <dd>B-BOX</dd> -->
            </dl>
            <textarea v-model="withdrawAddress" rows="3"></textarea>
          </div>
          <dl
            class="dl-horizontal dl-withdraw"
            v-if="selectedWallet.coin.code === 'XRP'"
          >
            <dt>데스티네이션 태그</dt>
            <dd class="text-gray">{{ destinationTag }}</dd>
          </dl>
          <div class="sms-confirm">
            <span class="timer">{{ SMSExpireFormatted }}</span>
            <div class="input-group">
              <vs-input
                type="text"
                pattern="[0-9]*"
                inputmode="decimal"
                label="SMS 인증번호 입력"
                placeholder="인증번호(6자리)를 입력하세요."
                class="input-custom"
                v-model="withdrawAuthValue"
              ></vs-input>
              <span class="input-group-btn">
                <vs-button
                  color="dark"
                  size="small"
                  class="btn-wide"
                  type="filled"
                  v-if="!withdrawSMSSend"
                  @click="sendSMS"
                  >발송</vs-button
                >
              </span>
            </div>
          </div>
          <p class="help-block help-withdraw">{{ $t("sms.info[1]") }}</p>
          <ul>
            <li>{{ $t("withdraw.confirmAddress") }}</li>
            <li>암호화폐 출금 시 입금주소를 꼭 확인해 주세요.</li>
            <li>{{ $t("withdraw.recovery") }}</li>
          </ul>
          <vs-checkbox v-model="agreeWithWithrawPolicy"
            >입금내역의 확인을 위해 선택된 거래내역을 제공합니다.</vs-checkbox
          >
          <vs-row class="btn-group">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-button
                color="#717171"
                type="filled"
                class="btn-block custom"
                @click="reset"
                >{{ $t("confirm.cancel") }}</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="8"
            >
              <vs-button
                color="#f01b5c"
                type="filled"
                class="btn-block custom"
                @click="submitWithdraw"
                >{{ $t("withdraw.withdrawal") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
        <!-- 출금1 코인 FORM//E -->
        <!-- 출금2 코인 FORM//S -->
        <div
          class="well withdraw-form"
          v-if="
            selectedWallet &&
              selectedWallet.coin.code !== 'KRW' &&
              withdrawSecondPhase &&
              useOTP
          "
        >
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="출금 수량(수수료 포함)"
            :placeholder="$t('withdraw.dinalWithdrawalQuantity')"
            disabled
            v-model="withdrawFinal"
            class="input-custom input-block disable-custom input-right withdraw-final"
          ></vs-input>
          <div class="transfer-wallet-address">
            <dl class="dl-horizontal">
              <dt>{{ $t("withdraw.depositAddress") }}</dt>
              <!-- <dd>B-BOX</dd> -->
            </dl>
            <textarea v-model="withdrawAddress" rows="3" disabled></textarea>
          </div>
          <dl
            class="dl-horizontal dl-withdraw"
            v-if="selectedWallet.coin.code === 'XRP'"
          >
            <dt>데스티네이션 태그</dt>
            <dd class="text-gray">{{ destinationTag }}</dd>
          </dl>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="OTP 인증번호 입력"
            placeholder="유효시간 안에 인증번호(6자리)를 입력하세요."
            class="input-custom input-block"
            v-model="withdrawAuthValue"
          ></vs-input>
          <ul>
            <li>암호화폐 출금 시 입금주소를 꼭 확인해 주세요.</li>
            <li>
              입금주소를 잘못 입력하실 경우 송금이 정상적으로 이루어지지 않아
              회원님의 자산을 찾지 못할 수 있습니다.
              <br />(리플의 경우 데스티네이션 태그를 반드시 입력해 주세요.)
            </li>
            <li>
              잘못된 암호화폐 송금에 대한 복구 작업은 본질적으로 큰 위험이
              따르고 오랜 시간을 소요하기 때문에 해당 문제가 발생될 경우
              FLYBIT는 어떠한 지원도 해드릴 수 없습니다.
            </li>
          </ul>
          <vs-checkbox v-model="agreeWithWithrawPolicy"
            >입금내역의 확인을 위해 선택된 거래내역을 제공합니다.</vs-checkbox
          >
          <vs-row class="btn-group">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-button
                color="#717171"
                type="filled"
                class="btn-block custom"
                @click="reset"
                >{{ $t("confirm.cancel") }}</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="8"
            >
              <vs-button
                color="#f01b5c"
                type="filled"
                class="btn-block custom"
                @click="submitWithdraw"
                >출금신청</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
        <!-- 출금2 코인 FORM//E -->
        <!-- 출금 탭//E -->
      </vs-tab>
    </vs-tabs>
    <vs-popup
      :title="$t('withdraw.addressBookManage')"
      fullscreen
      :active.sync="popupDepositAddress"
    >
      <!-- 등록//S -->
      <div class="panel panel-dark deposit-address">
        <div
          class="panel-heading"
          v-on:click="active = !active"
          :class="{ active: active }"
        >
          {{ $t("withdraw.depositRegister") }}
          <span class="icon-arrow"></span>
        </div>
        <transition name="fade">
          <div class="panel-body" v-if="active">
            <div
              class="input-master input-block vs-con-input input-custom vs-con-input-label"
            >
              <input
                type="text"
                :placeholder="$t('withdraw.enterAddressName')"
                class="form-control"
                v-model="depositAddressName"
              />
            </div>
            <div
              class="input-master input-block vs-con-input input-custom vs-con-input-label"
            >
              <input
                type="text"
                :placeholder="$t('withdraw.enterDepositAddress')"
                class="form-control"
                v-model="depositAddress"
              />
            </div>
            <!-- <vs-input label="주소이름" placeholder="주소이름을 입력하세요." class="input-block input-custom" v-model="depositAddressName"></vs-input>
              <div class="input-master input-custom vs-con-input-label">
                <label for="" class="vs-input-label"></label>
                <input type="number" placeholder="입금주소를 입력하세요." class="form-control" v-model="depositAddress">
            </div>-->
            <!-- <vs-input label="입금주소" placeholder="입금주소를 입력하세요." class="input-block input-custom" v-model="depositAddress"></vs-input> -->
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="3"
              >
                <vs-button
                  color="#717171"
                  @click.prevent="popupDepositAddress = false"
                  class="btn-gray btn-block"
                  >{{ $t("confirm.cancel") }}</vs-button
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="9"
              >
                <vs-button
                  color="#f01b5c"
                  @click="registAddr"
                  class="btn-block custom"
                  type="filled"
                  >{{ $t("confirm.ok") }}</vs-button
                >
              </vs-col>
            </vs-row>
          </div>
        </transition>
      </div>
      <!-- 등록//E -->
      <!-- 주소록//S -->
      <div class="deposit-address-list">
        <ul>
          <li
            v-for="(addressinfo, index) in addressList"
            :key="index"
            :class="{ active: addressinfo.address == pickWallet }"
            @click="pickWallet = addressinfo.address"
          >
            <div class="panel panel-gray">
              <div class="panel-heading">
                <h4 class="clearfix">
                  {{ addressinfo.name }} ({{ addressinfo.coincode }})
                  <small class="pull-right">{{ addressinfo.market }}</small>
                </h4>
              </div>
              <div class="panel-body">
                <div class="address-wrap">
                  <p>{{ $t("withdraw.depositAddress") }}</p>
                  <span>{{ addressinfo.address }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 주소록//E -->
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-button
            color="#717171"
            @click.prevent="popupDepositAddress = false"
            class="btn-gray btn-block"
            >{{ this.$t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
          <vs-button
            color="primary"
            @click="selectedAddress"
            class="btn-block custom"
            type="filled"
            >{{ $t("withdraw.selectionComplete") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 보인인증 진행 안내//S -->
    <vs-popup
      :title="$t('selfCertification.title')"
      :active.sync="accountAuthFailModal"
    >
      <p
        class="text-center"
        v-html="$t('selfCertification.completeAuthenticationProcess')"
      ></p>
      <p
        class="text-center"
        v-html="$t('selfCertification.completeRequired')"
      ></p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="(accountAuthFailModal = false), $router.back()"
            class="btn-gray btn-block"
            >{{ $t("selfCertification.later") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="
              (accountAuthFailModal = false), $router.push({ name: 'confirm' })
            "
            class="btn-block custom"
            type="filled"
            >{{ $t("selfCertification.goTo") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 회원가입 불가 안내//E -->
    <!-- POPUP 계좌등록 진행 안내//S -->
    <vs-popup
      :title="$t('selfCertification.title')"
      :active.sync="accountAuthFailModal2"
    >
      <p
        class="text-center"
        v-html="$t('selfCertification.completeAuthenticationProcess')"
      ></p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="accountAuthFailModal2 = false"
            class="btn-gray btn-block"
            >{{ $t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="
              (accountAuthFailModal2 = false), $router.push({ name: 'confirm' })
            "
            class="btn-block custom"
            type="filled"
            >{{ $t("confirm.ok") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 계좌등록 진행 안내//E -->
    <!-- POPUP 모바일 입금불가//S -->
    <vs-popup
      :title="$t('unableMobile.title')"
      :active.sync="mobileFailPopup"
      :button-close-hidden="true"
    >
      <p class="text-center" v-html="$t('unableMobile.deposit')"></p>
      <vs-button
        color="primary"
        @click="closeMobileFailPopup()"
        class="btn-block custom"
        type="filled"
        >{{ $t("confirm.ok") }}</vs-button
      >
    </vs-popup>
    <!-- POPUP 모바일 입금불가//E -->
    <!-- POPUP 입금확인//S -->
    <vs-popup title="입금확인" :active.sync="popupDepositConfirm">
      <p class="text-center">
        유진투자증권 계좌 {{ accounts.deposit.accountNumber }}에서
        <br />
        {{ depositAmount }}을 FLYBIT KRW로 <br />입금 신청 하시겠습니까?
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="popupDepositConfirm = false"
            class="btn-gray btn-block"
            >취소</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click.prevent="depositRegistConfirm"
            class="btn-block custom"
            type="filled"
            >확인</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 입금확인//E -->
    <!-- POPUP 입금 신청 완료//S -->
    <vs-popup title="입금 신청 완료" :active.sync="popupDepositComplete">
      <p class="text-center">
        {{ depositAmount2 }} KRW를 입금 신청 완료 되었습니다.
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            onclick="window.location.href='/withdrawlist'"
            class="btn-gray btn-block"
            >KRW 입출금 내역</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click.prevent="popupDepositComplete = false"
            class="btn-block custom"
            type="filled"
            >확인</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 입금 신청 완료//E -->
    <!-- POPUP 입금/출금 실패//S -->
    <vs-popup :title="errorPopupTitle" :active.sync="popupDepositErr">
      <p class="text-center" v-html="errorMessage"></p>
      <vs-button
        color="primary"
        @click.prevent="popupDepositErr = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 입금/출금//E -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as QRGenerator from "qr-image";
import Clipboard from "copy-to-clipboard";
import { parseAndConvertCashAddress } from "@/common/BchParser";
import Decimal from "decimal.js";
import Numeral from "numeral";
// import { setInterval } from "timers";
import Api from "@/common/Api";

// 라이트코인 주소 변환
function convertLTCAddr(address) {
  try {
    const decoded = bitcoin.address.fromBase58Check(address);
    let version = decoded["version"];
    let message = "";

    switch (version) {
      case 5:
        message = "Mainnet p2sh address: ";
        version = 50;
        break;
      case 50:
        message = "Mainnet p2sh address (deprecated): ";
        version = 5;
        break;
      case 196:
        message = "Testnet p2sh address: ";
        version = 58;
        break;
      case 58:
        message = "Testnet p2sh address (deprecated): ";
        version = 196;
        break;
      default:
        throw "unknown";
    }
    // 5 <-> 50
    // 196 <-> 58
    address = bitcoin.address.toBase58Check(decoded["hash"], version);
  } catch (err) {
    message = "Please enter a valid address.";
    address = "";
  }

  return address;
}

function defaultState() {
  return {
    mobileFailPopup: false,
    actives: 0,
    coinsel: false,
    favorite: false,
    checkBox1: false,
    selectedCoin: { coin: {} },
    availableAmount: "",
    depositAmount: "",
    depositAmount2: "",
    withdrawAmount: 0,
    transferAddress:
      "4HmoXnbeopf9V2TnSNrhjCdB9WT95a4nseV86vZKtqPoSxP5gnWjdLaAGnsNy3dXvwaq78t4MSA5GGWs9DQ",
    destinationTag: "",
    walletDefault: {},
    withdrawLimits: {},
    withdrawAddress: "",
    withdrawSecondPhase: false,
    agreeWithWithrawPolicy: false,
    withdrawResult: {},
    withdrawAuthValue: "",
    withdrawSMSTimer: null,
    withdrawSMSSend: false,
    withdrawSMSToken: "",
    withSMSExpiresAt: new Date(),
    SMSExpireFormatted: "",
    popupDepositAddress: false,
    active: false,
    addressList: [],
    pickWallet: undefined,
    depositAddressName: "",
    depositAddress: "",
    accountAuthFailModal: false,
    accountAuthFailModal2: false,
    popupDepositConfirm: false,
    popupDepositComplete: false,
    popupDepositErr: false,
    errorMessage: "",
    errorPopupTitle: "",
    totalOutAmount: "",
    accounts: {
      deposit: {
        bankName: "",
        accountNumber: "",
      },
    },
  };
}

export default {
  name: "withdraw",
  data() {
    return defaultState();
  },
  created() {
    // let temp = this.$store.getters.accounts
    // if(temp.deposit){
    //   this.accounts = deposit
    // }
    // this.accounts = this.$store.getters.accounts
    // 본인 인증 & 계좌 등록 여부 확인
    if (this.$route.query.activeTab == 0) {
      this.mobileFailPopup = true;
      return false;
    } else {
      if (this.$route.query.activeTab == undefined) {
        this.mobileFailPopup = true;
        return false;
      }
      if (this.authLevel < 3) {
        this.accountAuthFailModal = true;
        return false;
      }
    }
    // this.$router.push("/withdraw?activeTab=1")
    // this.$router.back();

    // if(this.accounts.deposit.bankName === '') {
    //   this.accountAuthFailModal = true;
    //   this.$router.push("/withdraw?activeTab=1")
    //   return false;
    // }
    // this.withdrawSMSTimer = setInterval( this.calcSMSTimer.bind(this), 1000);
    // this.$vs.loading()
    // Api.User.getAccountAvailableAmount({ bankCode : '280', accountNumber : this.accounts.deposit.accountNumber})
    // .then(response => {
    //   const availableAmt = _.get(response, ['data', 'result', 'availableAmt'], 0);
    //   this.availableAmount = Numeral(availableAmt).format("0,0")
    // }).catch(e => {
    //   console.log(e);
    // }).finally(()=>{
    //   this.$vs.loading.close()
    // });
  },
  watch: {
    "$route.query.activeTab"() {
      if (this.$route.query.activeTab == 0) {
        this.mobileFailPopup = true;
        return false;
      }
      if (this.$route.query.activeTab == undefined) {
        this.mobileFailPopup = true;
        return false;
      }
      // if(this.accounts.deposit.bankName === '' && this.$route.query.activeTab == 0) {
      //   this.accountAuthFailModal = true;
      //   this.$router.push("/withdraw?activeTab=1")
      //   return false;
      // }
      //this.sidebarActive = false;
      //console.log(this.$route.query.activeTab)
    },
    // depositAmount: function( num ){
    // this.depositAmount = Numeral(num).format("0,0")
    // },
    // withdrawAmount: function(num){
    // this.withdrawAmount = Numeral(num).format("0,0")
    // const value = this.withdrawAmount.replace(',', '')
    // const sum = + value + this.outFee
    // this.totalOutAmount = Numeral(sum).format("0,0")
    // }
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "authLevel",
      "coinWallet",
      "wallet",
      "useOTP",
      "toKRW",
    ]),
    coinList() {
      const coinList = this._.map(this.coinWallet, (wallet) => {
        let result = {};
        if (wallet.coin) {
          result = {
            ...wallet,
            value: wallet.coinId,
            text: `${wallet.coin.name}(${this.$bnCode(wallet.coin.code)})`,
            code: wallet.coin.code,
            address: wallet.address,
            destinationTag: this._.get(wallet, ["tag"]),
            sort: wallet.coin.sort,
            active: wallet.coin.inOutEnable === "Y",
          };
        }
        return result;
      });
      return _.sortBy(coinList, ["sort"]);
    },
    walletList() {
      return this._.filter(
        this.$store.state.Market.coin,
        (coin) => coin.inOutEnable === "Y" && coin.code !== "KRW"
      ).map((coin) => {
        const wallet = _.get(this.wallet, [coin.id], {});
        return {
          ...wallet,
          value: coin.id,
          text: `${coin.name}(${this.$bnCode(coin.code)})`,
          code: coin.code,
          destinationTag: this._.get(wallet, ["tag"]),
          active: coin.inOutEnable === "Y",
        };
      });
      /*
      return this._.map(this.$store.state.Market.coin, coin => {
        const wallet = _.get(this.wallet, [coin.id], {});
        return {
          ...wallet,
          value: coin.id,
          text: `${coin.name}(${coin.code})`,
          code: coin.code,
          destinationTag: this._.get(wallet, ['tag']),
          active: coin.inOutEnable === 'Y',
        }
      })
      */
    },
    address() {
      return this._.get(this, ["selectedCoin", "address"], "");
    },
    selectedWallet() {
      const wallet = this.wallet[this.walletDefault.value];
      // ( wallet )
      return wallet;
    },
    maxWithdrawAmount() {
      if (!this.withdrawLimits) {
        this.withdrawAmount = this.selectedWallet.minOut;
      }
      const maxAmount = this._.min([
        this.withdrawLimits.once,
        this.withdrawLimits.day,
        this.withdrawLimits.month,
        +Decimal(this.selectedWallet.available).sub(
          this.selectedWallet.coin.outFee
        ),
      ]);
      if (maxAmount < 0) {
        return 0;
      }
      return maxAmount;
    },
    tabIdx() {
      if (this.$refs.transferTab) {
        return this.$refs.transferTab.childActive;
      }
      return 0;
    },
    withdrawFinal() {
      const amount = parseFloat(this.withdrawAmount) || 0;
      return +Decimal(amount).add(this.selectedWallet.coin.outFee);
    },
  },
  methods: {
    closeMobileFailPopup() {
      this.mobileFailPopup = false;
      this.$router.back();
      //this.$router.push('?activeTab=1');
      // this.$router.push('/');
      // return true;
      //this.$router.back()
    },
    depositRegistConfirm() {
      this.$vs.loading();
      const amount = this.depositAmount.replace(",", "");
      Api.Transfer.transferKRW({
        mode: "deposits",
        bankCode: "280",
        amount: amount,
        deviceType: this.$deviceType(),
      })
        .then((response) => {
          this.popupDepositComplete = true;
          this.depositAmount = "";
          this.depositAmount2 = amount;
        })
        .catch((e) => {
          const code = _.get(e, ["response", "data", "header", "code"]);
          this.errorPopupTitle = "입금 제한";
          switch (code) {
            case "7100":
              const error = _.get(e, ["response", "data", "header", "message"]);
              this.errorPopupTitle = "입금 제한";
              this.errorMessage = `은행전산시스템 점검으로 인하여<br><span class="txt-blue">${error} 까지</span><br>플라이빗에서 입금 서비스 이용이 제한됩니다.`;
              this.popupDepositErr = true;
              break;
            default:
              this.errorMessage = _.get(e, [
                "response",
                "data",
                "header",
                "message",
              ]);
              this.popupDepositErr = true;
              break;
          }
        })
        .finally(() => {
          this.popupDepositConfirm = false;
          this.$vs.loading.close();
        });
    },
    depositRegist() {
      if (!this.depositAmount || this.depositAmount == 0) {
        this.$vs.notify({
          title: "알림",
          text: "입금 금액을 입력하세요.",
          position: "top-right",
          color: "danger",
        });
        return false;
      }
      this.popupDepositConfirm = true;
    },
    registAddr() {
      if (!this.depositAddressName) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          text: this.$t("notice.content.enteraddressName"),
          position: "top-right",
          color: "danger",
        });
        return false;
      }

      if (!this.depositAddress) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          text: this.$t("notice.content.enterAddress"),
          position: "top-right",
          color: "danger",
        });
        return false;
      }

      if (
        !this.selectedWallet.coin.code === "XRP" &&
        !this.selectedWallet.tag
      ) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          text: this.$t("notice.content.enterDestinationTag"),
          position: "top-right",
          color: "danger",
        });
      }

      Api.User.addAddr({
        coinId: this.selectedWallet.coinId,
        address: this.depositAddress,
        tag: this.selectedWallet.tag,
        name: this.depositAddressName,
      }).then((response) => {
        this.$vs.notify({
          title: this.$t("notice.title.uploaded"),
          text: this.$t("notice.content.newAddressUpdated"),
          position: "top-left",
        });
        this.depositAddress = "";
        this.depositAddressName = "";

        this.getAddrData({
          coinId: this.selectedWallet.coinId,
          page: 1,
        });
      });
    },
    getAddrData(options = {}) {
      const params = {
        count: 300,
        ...options,
      };

      Api.User.getAddrList(params).then((response) => {
        this.addressList = response.body;

        // if (_.has(options, "coinId")) {
        //   this.addresses = response.body;
        //   this.pagination = response.pagination;
        //   this.pagination.total = _.get(response.body, [0, "CNT"], 0);
        // } else {
        //   this.addresses = response.body;
        //   this.addrData.addrList = response.body;
        //   this.pagination = response.pagination;
        //   this.pagination.total = _.get(response.body, [0, "CNT"], 0);
        // }
      });
    },
    reset: function() {
      for (let k in this.$data) {
        this.$data[k] = defaultState()[k];
      }
      this.init();
    },
    init() {
      this.$store.dispatch("getUserWallet").then(() => {
        for (let i in this.walletList) {
          if (this.walletList[i].code == "BTC") {
            this.initCoinData(this.walletList[i]);
          }
        }

        for (let i in this.coinList) {
          if (this.coinList[i].code == "BTC") {
            this.initWalletData(this.coinList[i]);
          }
        }
      });
    },
    shareAddr() {
      if (navigator.share) {
        let text = "";
        if (this.destinationTag) {
          text = "address: " + this.selectedCoin.address;
          text += "\ndestination: " + this.selectedCoin.destinationTag;
        } else {
          text = this.selectedCoin.address;
        }
        navigator.share({
          title: `[FLYBIT] ${this.selectedCoin.text} 주소`,
          text: this.selectedCoin.address,
        });
      }
    },
    copyToClipboard() {
      let text = "";
      if (this.destinationTag) {
        text = "address: " + this.selectedCoin.address;
        text += "\ndestination: " + this.selectedCoin.destinationTag;
      } else {
        text = this.selectedCoin.address;
      }
      Clipboard(text);
      this.$vs.notify({
        title: this.$t("notice.title.copied"),
        // message: this.$t(`${this.selectedCoin.text} 입금주소가 복사되었습니다.`),
        message: this.$t(`notice.content.addressCopied`, [
          this.selectedCoin.text,
        ]),
        type: "warning",
        customClass: "FLYBIT-noti",
        position: "top-left",
      });
    },
    initCoinData(coin) {
      if (coin.code === "KRW") {
        // this.$vs.notify({
        //   title: '안내',
        //   text: 'KRW 입금은 준비 중입니다.',
        //   color: 'danger',
        //   position: "top-right"
        // });
        // return false;
        // if(!this.accounts.deposit){
        //   this.accountAuthFailModal = true;
        //   return false;
        // }
      }
      if (coin && !coin.address) {
        return Api.User.createWallet(coin.value).then((response) => {
          let { address, tag, available, total } = response.body;
          switch ((coin.code || "").toUpperCase()) {
            case "BCH":
              // 비트코인 캐시 주소 parse
              try {
                address = parseAndConvertCashAddress(address);
              } catch (e) {}
              break;
            case "LTC":
              // 라이트코인 캐시 주소 parse
              try {
                address = convertLTCAddr(address);
              } catch (e) {}
              break;
          }

          const qr = QRGenerator.imageSync(address, { type: "svg" });
          this.selectedCoin = {
            ...coin,
            address,
            toKRW: new Decimal(this.toKRW(coin.code).price)
              .mul(_.get(coin, "available", 0))
              .toNumber(),
            qr,
          };
        });
      } else {
        const qr = QRGenerator.imageSync(coin.address, { type: "svg" });
        this.selectedCoin = {
          ...coin,
          toKRW: new Decimal(this.toKRW(coin.code).price)
            .mul(coin.available)
            .toNumber(),
          qr,
        };
      }
      this.coinsel = false;
    },
    initWalletData(wallet) {
      // if(wallet.code === "KRW"){
      //   this.$vs.notify({
      //     title: '안내',
      //     text: 'KRW 출금은 준비 중입니다.',
      //     color: 'danger',
      //     position: "top-right"
      //   });
      //   return false;
      // }
      if (wallet.code === "KRW") {
        this.mobileFailPopup = true;
        return false;
      }

      if (this.accounts.deposit.bankName == "") {
        this.bankName = this.accounts.deposit.bankName;
        this.accountNumber = this.accounts.deposit.accountNumber;
      }

      this.outFee = _.get(wallet, ["coin", "outFee"], 0);

      this.pickWallet = "";
      this.withdrawAddress = "";
      if (this.withdrawSecondPhase) {
        return false;
      }
      this.walletDefault = wallet;
      this.coinsel = false;
      Api.Transfer.getWithdrawLimit(wallet.value).then((response) => {
        this.withdrawLimits = response.body.limit;
        this.withdrawAmount = _.get(wallet, ["coin", "minOut"], 0);
      });
    },
    setMaxWithdrawal() {
      if (this.maxWithdrawAmount <= 0) {
        return 0;
      }
      this.withdrawAmount = this.maxWithdrawAmount;
    },
    async toNextWithdrawPhase() {
      if (this.withdrawAmount < this.selectedWallet.coin.minOut) {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          // text: `출금 가능한 수량를 확인해주세요.<br> 수수료를 제외한<br>최소 출금수량은 ${this.selectedWallet.coin.minOut} 이상 입니다.`,
          text: this.$t("notice.content.minimumWithdrawalAmount", [
            this.selectedWallet.coin.minOut,
          ]),
          color: "danger",
          position: "top-right",
        });
        return false;
      }
      // ... validation
      // selectedWallet.available
      if (this.withdrawFinal > this.selectedWallet.available) {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          text: "출금액이 가능 액수보다 큽니다.",
          color: "danger",
          position: "top-right",
        });
        return false;
      }
      if (!this.withdrawAddress && this.selectedWallet.coin.code !== "KRW") {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          text: this.$t("notice.content.enterAddress"),
          color: "danger",
          position: "top-right",
        });
        return false;
      }
      if (this.selectedWallet.coin.code === "XRP" && !this.destinationTag) {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          text: "데스티네이션 태그를 입력해 주세요.",
          color: "danger",
          position: "top-right",
        });
        return false;
      }

      const isPolicy = await Api.isPolicyChange()
        .then((res) => true)
        .catch((e) => {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: e.response.data.header.message,
            color: "danger",
            position: "top-right",
          });
          return false;
        });
      const isKrwDays = await Api.getKrwDays()
        .then((res) => true)
        .catch((e) => {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: this.$t("notice.content.72hoursLastKRWDeposit"),
            color: "danger",
            position: "top-right",
          });
          return false;
        });

      if (isPolicy && isKrwDays) {
        this.withdrawSecondPhase = true;
      }
    },
    submitWithdraw() {
      if (!this.agreeWithWithrawPolicy) {
        this.$vs.notify({
          title: "안내",
          text: "거래내역 제공에 동의해 주세요",
          position: "top-right",
          color: "danger",
        });
        return false;
      }
      if (!this.withdrawAuthValue) {
        this.$vs.notify({
          title: "안내",
          text: "인증번호를 입력해주세요.",
          position: "top-right",
          color: "danger",
        });
        return false;
      }
      const params = {
        coinId: this.selectedWallet.coinId,
        amount: this.withdrawAmount,
        // amount: this.withdrawAmount.replace(',', ''),
        toAddress: this.withdrawAddress,
        transferType: "O",
        authType: this.useOTP ? "OTP" : "SMS",
        authValue: this.withdrawAuthValue,
      };
      if (!this.useOTP) {
        params.authToken = this.withdrawSMSToken;
      }

      const error = (e) => {
        const msg = _.get(e, "msg", "서버오류");
        const { code, message } = _.get(e, ["response", "data", "header"]);
        // if(code === 4052) {
        //   this.CertificationModal.show = true;
        //   this.CertificationModal.num = message;
        //   return false;
        // }
        this.withdrawResult = {
          ...e,
          msg,
        };
        this.errorPopupTitle = "출금 제한";
        switch (code) {
          case "7100":
            const error = _.get(e, ["response", "data", "header", "message"]);
            this.errorMessage = `은행전산시스템 점검으로 인하여<br><span class="txt-blue">${error} 까지</span><br>플라이빗에서 출금 서비스 이용이 제한됩니다.`;
            this.popupDepositErr = true;
            break;
          default:
            this.errorMessage = _.get(e, [
              "response",
              "data",
              "header",
              "message",
            ]);
            this.popupDepositErr = true;
            break;
        }

        if (_.get(e, "code") === 5100) {
          this.$router.push({ name: "Main" });
          return true;
        }
      };

      if (this.selectedWallet.coin.code === "KRW") {
        params.mode = "withdraw";
        params.backCode = "280";
        params.deviceType = this.$deviceType();
        Api.Transfer.transferKRW(params)
          .then((response) => {
            this.$vs.notify({
              title: this.$t("notice.title.done"),
              text: this.$t("withdraw.description"),
              position: "top-left",
            });
            this.reset();
            // this.withdrawResult = response.body;
            // this.withdrawResult.toAddress = this.accounts.deposit.accountNumber;
            // this.withdrawResult.finalAmount = Decimal(response.body.amount).add(response.body.fee).toNumber();
            // this.withdrawSuccessModal = true;
          })
          .catch(error);
      } else {
        Api.Transfer.transferAsset(params)
          .then((response) => {
            let withdrawResult = response.body;
            withdrawResult.finalAmount = Decimal(response.body.amount)
              .add(response.body.fee)
              .toNumber();
            this.$vs.notify({
              title: this.$t("notice.title.done"),
              text: this.$t("withdraw.description"),
              position: "top-left",
              // buttons: [
              //   { type: 'OK', text: '확인', onClick: () => this.reset },
              // ]
            });
            this.withdrawSecondPhase = false;
            this.withdrawAddress = "";
          })
          .catch(error);
      }
    },
    openAddressBook() {
      // 모바일 아직 미지원
      //this.$ev.$emit('notInMobile');
      this.popupDepositAddress = true;
      this.getAddrData({
        coinId: this.selectedWallet.coinId,
        page: 1,
      });
    },
    sendSMS() {
      Api.User.sendSMS().then((response) => {
        this.resetSMSTimer();
        this.withdrawSMSToken = _.get(response, ["body", "requestCode"]);
      });
    },
    calcSMSTimer() {
      if (!this.withdrawSMSSend) {
        return false;
      }
      this.SMSExpireFormatted = this.moment(this.SMSExpire()).format("mm:ss");
      if (this.SMSExpire() < 0) {
        this.withdrawSMSSend = false;
      }
    },
    SMSExpire() {
      return this.moment(this.withSMSExpiresAt - this.moment());
    },
    resetSMSTimer() {
      this.withSMSExpiresAt = this.moment().add(3, "m");
      this.withdrawSMSSend = true;
    },
    checkAuth(e) {
      if (this.authLevel < 3) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // this.$ev.$emit("suggestUserAuth");
        setTimeout(() => {
          this.$refs.transferTab.activeChild(new Event(), 0);
        }, 1000);
      }
    },
    selectedAddress() {
      this.withdrawAddress = this.pickWallet;
      this.popupDepositAddress = false;
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    clearInterval(this.withdrawSMSTimer);
  },
};
</script>
<style>
.input-total .vs-input--input:after {
  content: "KRW";
  display: inline-block;
}
.input-total .vs-input--input:disabled {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  opacity: 1;
  text-align: right;
}
</style>
